import { BrowserRouter as Router } from "react-router-dom";

import Pages from "./routes";

function App() {
  return (
    <Router>
      <Pages />
    </Router>
  );
}

export default App;
